export default "__VITE_ASSET__35ea99cd__"